import { GlobalStore } from "@roc/feature-app-core";
import ScopeOfWorkV2Store from "./scopeOfWorkV2Store";
import { ScopeOfWorkV2, ScopeOfWorkV2FormParams } from "@roc/feature-sow-shared/types";
import { CALLBACK_TYPE } from "@roc/feature-sow-shared/constants/scopeOfWorkV2Form";
import { flow, makeObservable } from "mobx";

const scopeOfWorkFormFields = {
  fields: {
    borrowerFirstName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The borrower first name is required.',
    },
    borrowerLastName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The borrower last name is required.',
    },
    borrowerEmailAddress: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The borrower email address is required.',
    },
    address: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The address is required.',
    },
    streetNumber: {
      value: null,
      error: null,
      rule: '',
      message: 'The street number is required.',
    },
    streetName: {
      value: null,
      error: null,
      rule: 'required',
      message: 'The street name is required.',
    },
    alreadyOwn: {
      value: true,
      error: null,
      rule: '',
    },
    anyImprovements: {
      value: null,
      error: null,
      rule: '',
    },
    city: {
      value: null,
      error: null,
      rule: '',
    },
    state: {
      value: null,
      error: null,
      rule: '',
    },
    zipCode: {
      value: null,
      error: null,
      rule: '',
    },
    originatorId: {
      value: null,
      error: null,
      rule: '',
    },
    projectDescription: {
      value: '',
      error: null,
      rule: '',
    },
    describeRenovation: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Special project type value is required.',
    },
    preRehabBedroomsCount: {
      value: null,
      error: null,
      rule: '',
    },
    postRehabBedroomsCount: {
      value: null,
      error: null,
      rule: '',
    },
    preRehabBathroomsCount: {
      value: null,
      error: null,
      rule: '',
    },
    postRehabBathroomsCount: {
      value: null,
      error: null,
      rule: '',
    },
    preRehabAproxSquareFootageAboveGrade: {
      value: null,
      error: null,
      rule: '',
    },
    postRehabAproxSquareFootageAboveGrade: {
      value: null,
      error: null,
      rule: '',
    },
    preRehabAproxSquareFootageBelowGrade: {
      value: null,
      error: null,
      rule: '',
    },
    postRehabAproxSquareFootageBelowGrade: {
      value: null,
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class PublicScopeOfWorkV2Store extends ScopeOfWorkV2Store {

  constructor(globalStore: GlobalStore) {
    super(globalStore, scopeOfWorkFormFields);
    this.inititalizeServiceMethods();
    makeObservable(this, {
      initLenderIdForShortLink: flow
    });
  }

  inititalizeServiceMethods() {
    this.setSubmitScopeOfWork(this.submitScopeOfWorkPublic)
  }

  setPublicParams(params: ScopeOfWorkV2FormParams) {
    this.params = params;
    this.fetchInitialData();
  }

  *fetchInitialData() {
    yield this.fetchScopeOfWork();
    if (!this.showShare) return;
  }

  *fetchScopeOfWork() {
    try {
      let response: ScopeOfWorkV2;
      response = yield this.getNewScopeOfWork();

      const categoriesResponse = yield this.getScopeOfWorkCategories();

      if (!response || !categoriesResponse) return;
      this.setIsDisabled(false);
      this.setIsPublicLink(true);
      this.params.isInternal = false;
      this.initParams(response);
      this.initScopeOfWork(response, categoriesResponse);
    } catch (error) {
      this.afterCall(CALLBACK_TYPE.GET, null, this.params.isInternal);
    }
  }

  submitScopeOfWorkPublic = async (
    params: ScopeOfWorkV2FormParams,
    data: any,
    silent: boolean
  ) => {
    const { data: response } = await this.scopeOfWorkService.submitScopeOfWorkPublic(
      params.lenderId,
      params.scopeOfWorkId,
      params.username,
      this.parseDataToSave(),
      silent
    );
    return response;
  };

  setPublicParamsWithoutLenderId(params: ScopeOfWorkV2FormParams) {
    this.params = params
    this.initLenderIdForShortLink();
    this.fetchInitialData();
  }

  *initLenderIdForShortLink() {
    let response: ScopeOfWorkV2;
    response = yield this.getLenderIdByHost();
    this.setParamsForShortLink(response);
  }

  setParamsForShortLink(response) {
    this.params.lenderId = response?.data;
  }

  getLenderIdByHost = async () => {
    try {
      const host = this.getHost();
      const { data: response } = await this.scopeOfWorkService.getLenderIdByHost(host);
      return response;
    } catch (err) {
      this.globalStore.notificationStore.showErrorNotification({
        message:
          'An error occurred when getting user information',
      });
    }
  }

  getHost() {
    return window.location.origin;
  }

  resetParamsWithConditions() {
    if (!this.params)
      this.reset();
  }
}